































import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component} from "vue-property-decorator";
import {ProvinceStore} from "@/modules/regionsv2/province/store";
import {FormModel} from "ant-design-vue";
import CountrySelectorV2 from "@/modules/regionsv2/CountrySelectorV2/index.vue";

const form = {
    code: undefined,
    name: undefined,
    countryId: undefined
}
@Component({
    name: "ProvinceForm",
    components: {CountrySelectorV2}
})
export default class extends mixins(CommonMixin) {
    form = { ...form };
    rules = {
        code: [{ required: true, message: "Nhập mã tỉnh" }],
        name: [{ required: true, message: "Nhập tên tỉnh" }],
        countryId: [{ required: true, message: "Chọn nước" }],
    }
    submit() {
        (this.$refs.form as FormModel).validate(async (valid) => {
            if (!valid) return;
            try {
                await ProvinceStore.createProvinceV21(this.form);
                this.resetForm();
                this.$message.success("Tạo tỉnh thành công");
            } catch (e) {
                this.$message.success("Tạo tỉnh thất bại");
            }
        })
    }
    resetForm() {
        this.form = { ...form };
    }
}
